<template>
    <div class="header-bar">
        <!--<div :class="titleCls">{{title}}</div>
        <sider-trigger style="float: left" :collapsed="collapsed" icon="md-menu"
                       @on-change="handleCollpasedChange"></sider-trigger>-->
        <span class="i-layout-header-trigger i-layout-header-trigger-min" @click="handleCollpasedChange(!collapsed)">
            <common-icon :type="collapsed?'_indent':'_outdent'" :size="23"/>
        </span>
        <span class="i-layout-header-trigger i-layout-header-trigger-min" @click="refresh">
            <common-icon type="_reload" :size="22"></common-icon>
        </span>
        <span class="i-layout-header-trigger i-layout-header-trigger-min">
            <fullscreen v-model="isFullscreen"/>
        </span>

        <custom-bread-crumb :list="list"></custom-bread-crumb>
        <!--<div style="float: left">
            <Menu mode="horizontal" :active-name="activeName"
                  @on-select="handleSelect">
                <MenuItem v-for="item in menuList" :name="item.menu_name">
                    <Icon :type="item.icon"/>
                    {{item.name}}
                </MenuItem>
            </Menu>
        </div>-->
        <div class="custom-content-con">
            <slot></slot>
        </div>
    </div>
</template>
<script>
    import siderTrigger from './sider-trigger'
    import customBreadCrumb from './custom-bread-crumb'
    import CommonIcon from '_c/common-icon'
    import Fullscreen from '@/module/base/components/fullscreen'
    import './header-bar.less'
    import * as _ from 'lodash';

    import iProperties from '@/module/base/api/iProperties'

    export default {
        name: 'HeaderBar',
        inject:['reload'],
        components: {
            siderTrigger,CommonIcon,customBreadCrumb,Fullscreen
        },
        props: {
            collapsed: Boolean,
            menuList: {
                type: Array,
                default() {
                    return []
                }
            }
        },
        data() {
            return {
                activeName: null,
                titleCls:'title',
                title:'工程机械监管平台',
                list:[],
                isFullscreen:false
            }
        },
        computed: {
            breadCrumbList() {
                return this.$store.state.app.breadCrumbList
            },

        },
        mounted() {
            const {name, query} = this.$route;
            this.activeName = this.getActiveName(name, query);
            this.handleSelect(this.activeName);
            this.init();
            this.list = [{name:'平台',meta:{title:'平台'}},
                ...this.$route.matched.filter(e => {
                    return typeof(e.meta.breadShow)=='undefined'||e.meta.breadShow==true
                })];
        },
        methods: {
            init(){
                iProperties.sysName().then(res=>{
                    if(res){
                        this.title = res;
                        document.title = res;
                    }
                })
            },
            handleCollpasedChange(state) {
                if(state){
                    this.titleCls = 'titleCollpased';
                }else{
                    this.titleCls = 'title';
                }
                this.$emit('on-coll-change', state)
            },
            handleSelect(name) {
                this.$emit('on-select', name);
            },
            getActiveName(name, query = {}) {
                return null
            },
            refresh() {
                this.reload()
            }
        },
        watch: {
            $route(to) {
                const {name, query} = to;
                this.activeName = this.getActiveName(name, query) || this.activeName;
                this.handleSelect(this.activeName);
                this.list = []
                this.list = [{name:'平台',meta:{title:'平台'}},
                    ...this.$route.matched.filter(e => {
                        return typeof(e.meta.breadShow)=='undefined'||e.meta.breadShow==true
                    })];
            }
        }
    }
</script>
<style scoped lang="less">
    .ivu-menu {
        z-index: 0;
    }

    .title{
        background-color:#011529;color:#FFFFFF;float:left;width:216px;box-sizing:border-box;font-size:18px;font-weight:700;padding-left:20px;
    }

    .titleCollpased{
        background-color:#011529;color:#FFFFFF;float:left;
        width:64px;box-sizing:border-box;font-size:18px;font-weight:700;padding-left:20px;
    }

    .i-layout-header-trigger {
        display:inline-block;
        width:64px;
        height:64px;
        text-align:center;
        cursor:pointer;
        transition:all .2s ease-in-out;
        line-height: 64px;
        vertical-align: bottom;
    }
    .i-layout-header-trigger:hover {
        /*background:#f8f8f9*/
        background:#000c17
    }
    .i-layout-header-trigger i {
        font-size:20px
    }
    .i-layout-header-trigger-min {
        width:auto;
        padding:0 12px
    }
    .i-layout-header-trigger-min i {
        font-size:18px
    }
    .i-layout-header-trigger-in {
        padding:0
    }
</style>
